import { render } from "./CreateAd.vue?vue&type=template&id=2837974d"
import script from "./CreateAd.vue?vue&type=script&lang=js"
export * from "./CreateAd.vue?vue&type=script&lang=js"
script.render = render

export default script